import { render, staticRenderFns } from "./OutputAssessmentOfTheRiskOfBias.vue?vue&type=template&id=dadafdde&scoped=true"
import script from "./OutputAssessmentOfTheRiskOfBias.vue?vue&type=script&lang=js"
export * from "./OutputAssessmentOfTheRiskOfBias.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dadafdde",
  null
  
)

export default component.exports